module.exports = __webpack_public_path__ + "./fonts/PPPangramSansRounded-Bold.otf";